/**
 * Terms of Use and Copyright Attribution page.
 */
import { InfoLayout } from "../../components/InfoLayout";

export function TermsPage() {
  return (
    <InfoLayout
      title="Terms &amp; Attribution"
      lead="How PyDialog uses curriculum standards, and what you can do with the content."
    >
      <div className="card">
        <h3>Purpose</h3>
        <p>
          PyDialog is an educational platform designed to help South African
          learners prepare for the National Senior Certificate (NSC) examinations
          through dialog-based assessment.
        </p>
      </div>

      <div className="card">
        <h3>Curriculum alignment</h3>
        <p>
          Content on this platform is aligned to the <strong>Curriculum and
          Assessment Policy Statement (CAPS)</strong> for the Further Education
          and Training (FET) Phase (Grades 10–12), as published by the Department
          of Basic Education (DBE), Republic of South Africa.
        </p>
        <p>
          Questions, topics, and learning objectives are structured to match the
          cognitive levels, content weightings, and assessment standards specified
          in the official CAPS documents for each subject.
        </p>
      </div>

      <div className="card">
        <h3>Source attribution</h3>
        <p>
          The curriculum structure, topic weightings, and examination format
          referenced in this platform are based on publicly available documents
          from the:
        </p>
        <blockquote>
          <strong>Department of Basic Education</strong><br />
          Republic of South Africa<br />
          <a href="https://www.education.gov.za" target="_blank" rel="noreferrer">
            www.education.gov.za
          </a>
        </blockquote>
        <p>
          PyDialog is <strong>not affiliated with, endorsed by, or officially
          connected to</strong> the Department of Basic Education. The DBE name
          and references to NSC examinations are used solely to describe the
          educational standards this platform is aligned to.
        </p>
      </div>

      <div className="card">
        <h3>Non-commercial use</h3>
        <p>
          This platform is provided for <strong>educational purposes only</strong>.
          Content may not be sold, redistributed for profit, or used for commercial
          purposes without explicit permission.
        </p>
      </div>

      <div className="card">
        <h3>Copyright</h3>
        <p>
          © {new Date().getFullYear()} PyDialog. The CAPS curriculum framework
          and NSC examination standards remain the intellectual property of the
          Department of Basic Education, Republic of South Africa.
        </p>
      </div>

      <div className="card">
        <h3>Contact</h3>
        <p>
          For questions about content attribution or to report concerns, please
          visit the <a href="/contact">Contact page</a>.
        </p>
      </div>
    </InfoLayout>
  );
}
